import { render } from "./SportsBar.vue?vue&type=template&id=d5177402&scoped=true"
import script from "./SportsBar.vue?vue&type=script&lang=js"
export * from "./SportsBar.vue?vue&type=script&lang=js"

import "./SportsBar.vue?vue&type=style&index=0&id=d5177402&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5177402"]])

export default __exports__